"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Cover = {
    elemName: '表紙',
    type: 'block',
    doc: '書籍の表紙部分を囲むブロックです',
    example: '％表紙\n《題：地震年代記》\n％',
    textTemplate: '{{{$1}}}',
    htmlTemplate: `<div {{{$htmlId}}} class="Cover {{$classes}}">{{{$1}}}</div>`,
    xmlTemplate: `<titlePage {{{$xmlId}}} {{{$xmlSubtypes}}}>{{{$1}}}</titlePage>`,
    docxTemplate: `<w:p>{{{$1}}}</w:p>`
};
exports.default = Cover;
// import { ConversionRule } from '../ConversionRule';
// import { KojiASTNode, KojiBlockNode } from '../../KojiAstBuilder';
// export default class Cover extends ConversionRule {
// 	get elemName() {
// 		return '表紙';
// 	}
// 	toXML(node: KojiASTNode): string {
// 		const text = this.convertChildren(node.children);
// 		let idStr = '',
// 			classesStr = '';
// 		if (node.id) idStr = `xml:id='${node.id}'`;
// 		if (node.classes) classesStr = `subtype='${node.classes.join(' ')}'`;
// 		return `<titlePage ${idStr} ${classesStr}>${text}</titlePage>`;
// 	}
// 	toText(node: KojiASTNode): string {
// 		const text = this.converter.convertChildren(node.children);
// 		return `${text}`;
// 	}
// 	toHTML(node: KojiBlockNode) {
// 		const text = this.convertChildren(node.children);
// 		return `<div class="block block${node.level} Cover" >${text}</div>`;
// 	}
// }
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ292ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29udmVydGVyL2Jsb2NrX3J1bGVzL0NvdmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsTUFBTSxLQUFLLEdBQW1CO0lBQzdCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLE9BQU87SUFDYixHQUFHLEVBQUUsa0JBQWtCO0lBQ3ZCLE9BQU8sRUFBRSxtQkFBbUI7SUFDNUIsWUFBWSxFQUFFLFVBQVU7SUFDeEIsWUFBWSxFQUFFLDhEQUE4RDtJQUM1RSxXQUFXLEVBQUUsaUVBQWlFO0lBQzlFLFlBQVksRUFBRSxxQkFBcUI7Q0FDbkMsQ0FBQztBQUVGLGtCQUFlLEtBQUssQ0FBQztBQUVyQixzREFBc0Q7QUFDdEQscUVBQXFFO0FBRXJFLHNEQUFzRDtBQUN0RCxvQkFBb0I7QUFDcEIsaUJBQWlCO0FBQ2pCLEtBQUs7QUFFTCxzQ0FBc0M7QUFDdEMsc0RBQXNEO0FBQ3RELG9CQUFvQjtBQUNwQixzQkFBc0I7QUFDdEIsZ0RBQWdEO0FBQ2hELDBFQUEwRTtBQUMxRSxvRUFBb0U7QUFDcEUsS0FBSztBQUVMLHVDQUF1QztBQUN2QyxnRUFBZ0U7QUFDaEUsc0JBQXNCO0FBQ3RCLEtBQUs7QUFFTCxpQ0FBaUM7QUFDakMsc0RBQXNEO0FBQ3RELHlFQUF5RTtBQUN6RSxLQUFLO0FBQ0wsSUFBSSJ9